import z from "zod";

export const CreateUploadPurchaseOrderSchema = z.object({
    description: z.string(),
    remarks: z.string(),
    order_date: z.string().min(1, "Issued date is required."),
    expiration_date: z.string().min(1, "Expiration date is required."),
    project: z.string().min(1, "Project name is required."),
    purchase_order_number: z
        .string()
        .min(1, "Purchase order number is required."),
    reference_number: z.string().min(1, "Reference number is required."),
    status: z.string(),
    rate_type: z.string().min(1, "Rate type is required."),
    supplier_id: z.string().min(1, "Supplier is required.").nullable(),
    client_id: z.string().min(1, "Client is required.").nullable(),
    type: z.string(),
    total_amount: z
        .number({ invalid_type_error: "Total amount must be a number." })
        .min(1, "Total amount must be greater than zero."),
    purchase_order_file_url: z.instanceof(FileList).optional(),
});

export const UpdateUploadPurchaseOrderSchema =
    CreateUploadPurchaseOrderSchema.extend({
        purchase_order_file_url: z.array(z.string()).nullable(),
        file: z.instanceof(FileList).nullable().optional(),
    });

export const UploadPurchaseOrderFormSchemaWithoutRefine =
    CreateUploadPurchaseOrderSchema.extend({
        file: z.instanceof(FileList).nullable().optional(),
        existing_purchase_order_file_url: z.array(z.string()).optional(),
    }).omit({
        purchase_order_file_url: true,
    });

export const UploadPurchaseOrderFormSchema =
    CreateUploadPurchaseOrderSchema.extend({
        file: z.instanceof(FileList).nullable().optional(),
        existing_purchase_order_file_url: z.array(z.string()).optional(),
    })
        .omit({
            purchase_order_file_url: true,
        })
        .refine(
            (data) =>
                new Date(data.expiration_date) > new Date(data.order_date),
            {
                message: "Expiration date must be later than the order date.",
                path: ["expiration_date"],
            },
        );

export type CreateUploadPurchaseOrderSchema = z.infer<
    typeof CreateUploadPurchaseOrderSchema
>;

export type UpdateUploadPurchaseOrderSchema = z.infer<
    typeof UpdateUploadPurchaseOrderSchema
>;
export type UploadPurchaseOrderFormSchema = z.infer<
    typeof UploadPurchaseOrderFormSchema
>;
